module.exports = __webpack_public_path__ + "static/media/Enrollment Kit_Combined Files (1).fcf2aa39.pdf";